import { Directive, ElementRef, HostListener } from '@angular/core';
import { isFunction } from 'lodash';

@Directive({
  selector: '[cslEnterLikeTab]',
})
export class EnterLikeTabDirective {
  private el: ElementRef;

  constructor(private _el: ElementRef) {
    this.el = this._el;
  }

  @HostListener('keydown', ['$event']) onKeyDown(e: any): void {
    if (+e.which === 13 || +e.keyCode === 13) {
      e.preventDefault();

      let nextControl: any;
      let controlIndex = 0;

      const controls: NodeList = this.el.nativeElement.querySelectorAll(
        'input:not([enterLikeTabIgnore]):not([type="checkbox"]), ' +
          'textarea:not([enterLikeTabIgnore]), button:not([enterLikeTabIgnore])'
      );

      [].forEach.call(controls, (elm: Node, index: number) => {
        if (elm === e.srcElement) {
          controlIndex = index + 1;
          nextControl = controls[controlIndex];
        }
      });

      while (true) {
        if (nextControl) {
          if (
            !nextControl.hidden &&
            !nextControl.disabled &&
            ((nextControl.nodeName as string).toUpperCase() === 'INPUT' ||
              // control.nodeName == 'SELECT' ||
              (nextControl.nodeName as string).toUpperCase() === 'BUTTON' ||
              (nextControl.nodeName as string).toUpperCase() === 'TEXTAREA')
          ) {
            nextControl.focus();
            if (isFunction(nextControl.select)) {
              nextControl.select();
            }

            return;
          } else {
            nextControl = controls[controlIndex++];
          }
        } else {
          return;
        }
      }
    }
  }
}
